import { Stack, useTheme } from "@mui/material";
import { FoodsIconButton, FormUnit } from "@foodpilot/foods";
import { usePropertyContext } from "../../../context/usePropertyContext";
import { MultiPropertyGroup } from "../../../context/utils/computeElementsGroup";
import { MultiElementsRow } from "../MultiElementsRow";
import { ItemTag } from "../ItemTag";

type MultiElementsGroupProps = {
    elementGroup: MultiPropertyGroup;
    deleteElement: (position: number) => void;
    showSubscore?: boolean | undefined;
    level?: number;
    itemNb: number;
};

export const MultiElementsGroup = (props: MultiElementsGroupProps) => {
    const theme = useTheme();
    const { itemNb, deleteElement, elementGroup } = props;
    const { canEdit, scoreUnit } = usePropertyContext();

    return (
        <Stack
            border={`1px solid ${theme.custom.grey[500]}`}
            borderRadius="8px"
            padding={{ xs: theme.spacing(2), sm: theme.spacing(2), md: theme.spacing(3) }}
            gap={theme.spacing(3)}
        >
            <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                <Stack flexDirection={{ xs: "column", sm: "row" }} gap={theme.spacing(1)}>
                    <ItemTag itemNb={itemNb} />
                    <Stack display={{ xs: "block", sm: "none" }}>
                        {elementGroup.multivalueLabel !== null && elementGroup.shouldDisplayScore && (
                            <FormUnit value={elementGroup.multivalueLabel} unit={scoreUnit} />
                        )}
                    </Stack>
                </Stack>
                <Stack flexDirection={"row"} gap={theme.spacing(1)}>
                    <Stack display={{ xs: "none", sm: "block" }}>
                        {elementGroup.multivalueLabel !== null && elementGroup.shouldDisplayScore && (
                            <FormUnit value={elementGroup.multivalueLabel} unit={scoreUnit} />
                        )}
                    </Stack>
                    {canEdit && (
                        <FoodsIconButton
                            size={"s"}
                            icon={"delete"}
                            withBackground
                            buttonProps={{
                                sx: {
                                    "&:hover": {
                                        backgroundColor: "rgba(238, 60, 21, 0.04)",
                                    },
                                    border: `1px solid #EE3C15`,
                                    color: `#EE3C15`,
                                },
                                onClick: () => deleteElement(elementGroup.position),
                            }}
                        />
                    )}
                </Stack>
            </Stack>
            {elementGroup.propertiesData.map((propertyData) => {
                return (
                    <Stack key={`index-coucou-${propertyData.property.id}`} direction="column" gap="8px">
                        <MultiElementsRow propertyData={propertyData} elementGroup={elementGroup} level={props.level} />
                    </Stack>
                );
            })}
        </Stack>
    );
};
